
document.addEventListener('DOMContentLoaded', function() {
  const mediaNone = document.querySelector('.product-information--media-none');
  if (mediaNone) {
    mediaNone.style.cssText = `
      display: grid !important;
      grid-template-columns: 1fr 1fr !important;
      gap: 40px !important;
      align-items: start !important;
    `;

    const img = document.createElement('div');
    img.style.cssText = `
      width: 100%;
      aspect-ratio: 1;
      background-image: url('https://arcd-shop.myshopify.com/cdn/shop/t/1/assets/placeholder.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      background-color: #f0f4f8;
      border-radius: 12px;
    `;

    // Als erste Spalte einfügen
    mediaNone.insertAdjacentElement('afterbegin', img);
  }
});